import { createDefaultProfile, createSavePayload, deriveCampaignProgress } from "../../game/engine/gameState";
import { clearCloudPayload, loadCloudPayload, saveCloudPayload } from "../firebase/saveService";
import { clearLocalSave, loadLocalSave, saveLocalPayload } from "./localStorageService";

const getPayloadTimestamp = (payload) => {
	if (!payload) return 0;
	return Math.max(
		Number(payload.savedAt) || 0,
		Number(payload.runState?.lastSavedAt) || 0,
	);
};

export const buildSavePayload = ({ user, profile, runState, settings, previousProgress = {} }) => {
	const progress = deriveCampaignProgress(runState, previousProgress);
	const snapshot = createDefaultProfile(user, profile || {});

	return createSavePayload({
		profile: snapshot,
		progress,
		runState,
		settings,
	});
};

export const saveGamePayload = async ({ user, payload }) => {
	saveLocalPayload(payload);

	if (user?.uid) {
		await saveCloudPayload(user.uid, payload);
		return "cloud";
	}

	return "local";
};

export const loadBestAvailableSave = async (user) => {
	const local = loadLocalSave();

	if (user?.uid) {
		const cloud = await loadCloudPayload(user.uid);
		const localStamp = getPayloadTimestamp(local);
		const cloudStamp = getPayloadTimestamp(cloud);

		if (cloud?.runState && cloudStamp >= localStamp) return { source: "cloud", payload: cloud };
		if (local?.runState) return { source: "local", payload: local };
	}

	return local?.runState ? { source: "local", payload: local } : null;
};

export const hasAnySave = async (user) => {
	const local = loadLocalSave();
	if (local?.runState) return true;

	if (user?.uid) {
		const cloud = await loadCloudPayload(user.uid);
		return Boolean(cloud?.runState);
	}

	return false;
};

export const clearSavedGame = async (user) => {
	clearLocalSave();

	if (user?.uid) {
		await clearCloudPayload(user.uid);
		return "cloud";
	}

	return "local";
};
